export const volunteerPositions = [
  {
    id: 1,
    title: "物资配送志愿者",
    icon: "ri-truck-line",
    responsibilities: [
      "协助物资装卸和搬运",
      "参与配送路线规划",
      "现场发放物资给受助者",
      "收集受助者反馈信息"
    ],
    timeRequirement: "每周至少1天，上午9:00-12:00或下午14:00-17:00",
    quota: "招募20人"
  },
  {
    id: 2,
    title: "活动策划志愿者",
    icon: "ri-calendar-event-line",
    responsibilities: [
      "策划公益活动方案",
      "协调活动资源和场地",
      "现场活动组织执行",
      "活动效果评估总结"
    ],
    timeRequirement: "每月至少参与1次活动，灵活安排",
    quota: "招募10人"
  },
  {
    id: 3,
    title: "宣传推广志愿者",
    icon: "ri-megaphone-line",
    responsibilities: [
      "撰写公益故事和新闻稿",
      "拍摄活动照片和视频",
      "运营社交媒体账号",
      "设计宣传海报和物料"
    ],
    timeRequirement: "线上为主，每周投入5-10小时",
    quota: "招募15人"
  },
  {
    id: 4,
    title: "数据管理志愿者",
    icon: "ri-database-2-line",
    responsibilities: [
      "录入捐赠和发放数据",
      "整理受助者申请资料",
      "制作数据统计报表",
      "维护信息系统数据"
    ],
    timeRequirement: "每周2-3天，可远程办公",
    quota: "招募8人"
  }
];

export const volunteerBenefits = [
  {
    icon: "ri-money-cny-circle-line",
    title: "交通补贴",
    description: "提供交通和餐饮补贴"
  },
  {
    icon: "ri-award-line",
    title: "志愿证书",
    description: "颁发志愿服务证书和时长证明"
  },
  {
    icon: "ri-book-open-line",
    title: "专业培训",
    description: "定期组织技能培训和分享会"
  },
  {
    icon: "ri-team-line",
    title: "团队活动",
    description: "参与团建和公益交流活动"
  },
  {
    icon: "ri-heart-line",
    title: "优先权益",
    description: "优先参与大型公益项目"
  },
  {
    icon: "ri-gift-line",
    title: "节日礼品",
    description: "节日慰问和生日祝福"
  }
];

export const volunteerGallery = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=Chinese%20volunteers%20distributing%20bottled%20water%20to%20sanitation%20workers%20on%20a%20sunny%20street%2C%20wearing%20green%20volunteer%20vests%2C%20smiling%20and%20interacting%20warmly%2C%20bright%20daylight%2C%20documentary%20photography%20style%2C%20authentic%20moment%2C%20simple%20urban%20background&width=400&height=500&seq=vol1&orientation=portrait",
    title: "街头送水活动",
    date: "2024-03-15"
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=Group%20of%20young%20Chinese%20volunteers%20sorting%20and%20packing%20bottled%20water%20in%20a%20warehouse%2C%20teamwork%20scene%2C%20organized%20boxes%20and%20supplies%2C%20bright%20indoor%20lighting%2C%20energetic%20atmosphere%2C%20simple%20warehouse%20background&width=400&height=300&seq=vol2&orientation=landscape",
    title: "物资整理现场",
    date: "2024-03-10"
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=Chinese%20volunteers%20taking%20group%20photo%20together%2C%20wearing%20green%20volunteer%20t-shirts%2C%20happy%20and%20united%2C%20outdoor%20setting%20with%20banner%2C%20natural%20lighting%2C%20team%20spirit%2C%20simple%20background&width=400&height=500&seq=vol3&orientation=portrait",
    title: "志愿者团队合影",
    date: "2024-03-08"
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=Chinese%20volunteer%20giving%20water%20to%20elderly%20delivery%20worker%20on%20electric%20bike%2C%20caring%20gesture%2C%20urban%20street%20scene%2C%20warm%20interaction%20moment%2C%20documentary%20style%2C%20simple%20city%20background&width=400&height=300&seq=vol4&orientation=landscape",
    title: "关爱快递员",
    date: "2024-03-05"
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=Chinese%20volunteers%20attending%20training%20session%20in%20meeting%20room%2C%20taking%20notes%20and%20listening%20attentively%2C%20professional%20setting%2C%20bright%20indoor%20lighting%2C%20learning%20atmosphere%2C%20simple%20office%20background&width=400&height=500&seq=vol5&orientation=portrait",
    title: "志愿者培训会",
    date: "2024-02-28"
  },
  {
    id: 6,
    image: "https://readdy.ai/api/search-image?query=Chinese%20volunteers%20distributing%20water%20at%20construction%20site%2C%20workers%20receiving%20bottles%20gratefully%2C%20safety%20helmets%20visible%2C%20outdoor%20construction%20environment%2C%20documentary%20photography%2C%20simple%20industrial%20background&width=400&height=300&seq=vol6&orientation=landscape",
    title: "工地送清凉",
    date: "2024-02-25"
  },
  {
    id: 7,
    image: "https://readdy.ai/api/search-image?query=Young%20Chinese%20volunteers%20preparing%20promotional%20materials%20and%20posters%20for%20charity%20event%2C%20creative%20workspace%2C%20colorful%20designs%2C%20indoor%20studio%20lighting%2C%20collaborative%20work%2C%20simple%20office%20background&width=400&height=500&seq=vol7&orientation=portrait",
    title: "宣传物料制作",
    date: "2024-02-20"
  },
  {
    id: 8,
    image: "https://readdy.ai/api/search-image?query=Chinese%20volunteers%20celebrating%20successful%20charity%20event%2C%20holding%20certificates%20and%20awards%2C%20joyful%20expressions%2C%20indoor%20venue%2C%20warm%20lighting%2C%20achievement%20moment%2C%20simple%20background&width=400&height=300&seq=vol8&orientation=landscape",
    title: "表彰优秀志愿者",
    date: "2024-02-15"
  }
];

export const volunteerStats = {
  totalVolunteers: 328,
  activeVolunteers: 156,
  serviceHours: 12450,
  activities: 89
};